import React from "react"

const StatusBadge = ({ status, meta }) => {
  const m = meta[status] ?? Object.values(meta)[0]
  return (
    <span
      className="d-inline-flex align-items-center"
      style={{
        gap: 6,
        padding: "3px 10px",
        borderRadius: 9999,
        fontSize: 11.5,
        fontWeight: 600,
        background: m.bg,
        color: m.color,
        lineHeight: 1.4,
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: m.dot, flexShrink: 0 }} />
      {status}
    </span>
  )
}

export default StatusBadge
